import { motion } from 'framer-motion'
import { fadeUp } from '../../lib/animations'

interface EmptyStateProps {
  icon: React.ReactNode
  title: string
  description: string
  action?: React.ReactNode
  className?: string
}

export function EmptyState({ icon, title, description, action, className = '' }: EmptyStateProps) {
  return (
    <motion.div
      {...fadeUp}
      className={`flex flex-col items-center justify-center py-16 px-6 text-center ${className}`}
    >
      <div className="w-16 h-16 rounded-2xl bg-warm-100 flex items-center justify-center text-warm-400 mb-4">
        {icon}
      </div>
      <h3 className="text-lg font-heading font-semibold text-midnight-800 mb-2">{title}</h3>
      <p className="text-warm-500 text-sm max-w-md mb-6">{description}</p>
      {action}
    </motion.div>
  )
}
